import {
	fileViewerPluginName,
	isWatermarkingAvailable,
} from '@sharefiledev/fileviewer-pilet-sdk';
import {
	PresetsByResourceType,
	PresetsByType,
	SelectedResource,
} from '@sharefiledev/sharing-pilet-sdk';
import { LinkSettings } from '@sharefiledev/sharing-pilet-sdk/api';
import { WatermarkConstants } from '../../constants';
import { isMultiLeafTypesPresent } from './linkShare-utils';

export const isWatermarkingAvailableForResources = (
	selectedResources: SelectedResource[],
	accountLevelLinkSettings: LinkSettings | undefined,
	consumerPluginName: string | undefined
): boolean => {
	if (consumerPluginName !== fileViewerPluginName) {
		return false;
	}
	const resourceRids = selectedResources.map(resource => resource.rid);
	if (!resourceRids || resourceRids.length === 0) {
		return false;
	}

	if (isMultiLeafTypesPresent(resourceRids)) {
		return false;
	}
	return isWatermarkingAvailable(
		selectedResources,
		accountLevelLinkSettings?.conditionalLink?.shareLinkSettings?.showWatermarkCheckbox ??
			false
	);
};

export const getPresetsForWatermarking = (
	isVersionEnabled: boolean,
	presetsByResourceType: PresetsByResourceType | undefined
): PresetsByType[] => {
	const resourceType = isVersionEnabled
		? WatermarkConstants.WatermarkedFileResourceType
		: WatermarkConstants.WatermarkedFileVersionResourceType;

	const presetsForResourceType = (presetsByResourceType ?? {})[resourceType];

	if (!presetsForResourceType || presetsForResourceType.length === 0) {
		return [];
	}
	return presetsForResourceType;
};
